import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "../translation";
import { loadPrevious } from "../../state/modules/search/actions";
import LoadButton from "./LoadButton";
import styles from "./ProductList.css";
import {
  getPagePath,
  PREVIOUS_PAGE
} from "../../state/modules/search/pageLinkSelectors";

export function LoadPreviousButton({
  isLoadingPrevious,
  loadPrevious,
  formatTranslation,
  formatLink,
  previousPagePath
}) {
  return (
    <LoadButton
      loadCallback={loadPrevious}
      isLoading={isLoadingPrevious}
      testId="loadPreviousProducts"
      linkUrl={formatLink(previousPagePath)}
      additionalClasses={styles.loadPrevious}
      formatTranslation={formatTranslation}
    >
      {formatTranslation("plp_web_search_load_previous_button_text")}
    </LoadButton>
  );
}

LoadPreviousButton.propTypes = {
  isLoadingPrevious: PropTypes.bool.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  formatLink: PropTypes.func.isRequired,
  loadPrevious: PropTypes.func.isRequired,
  previousPagePath: PropTypes.string.isRequired
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isLoadingPrevious: state.search.isLoadingPrevious,
    previousPagePath: getPagePath({ state, direction: PREVIOUS_PAGE })
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadPrevious: () => dispatch(loadPrevious())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(LoadPreviousButton));
